import React, { useState, useEffect } from "react";
import { ExternalLink, CheckCircle, Smartphone } from "lucide-react";

const GlobalAdBannerBelowHeader = () => {
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("bancaflow_banner_enabled");
    setIsEnabled(stored === "true");
  }, []);

  if (!isEnabled) return null;

  return (
    <a
      href="https://bancaflow.mentepoderosa2030.com/"
      target="_blank"
      rel="noopener noreferrer"
      className="block w-full group"
      title="👉 Conheça a BancaFlow — Crie sua banca online"
    >
      <div className="w-full bg-gradient-to-r from-emerald-900 via-emerald-800 to-emerald-900 border-b border-emerald-700/50 overflow-hidden">
        <div className="container mx-auto px-4 py-4 md:py-5">
          <div className="flex items-center justify-between gap-3 md:gap-6">
            {/* Left side - Badge */}
            <div className="hidden sm:flex items-center gap-2 bg-emerald-950/60 rounded-lg px-3 py-2 border border-emerald-600/30">
              <CheckCircle className="h-5 w-5 text-amber-400 flex-shrink-0" />
              <div className="text-xs md:text-sm">
                <span className="text-amber-400 font-semibold">Plataforma</span>
                <br />
                <span className="text-white/90">Completa e Segura</span>
              </div>
            </div>

            {/* Center - Main Text */}
            <div className="flex-1 text-center">
              <div className="flex flex-col md:flex-row items-center justify-center gap-1 md:gap-3">
                <div className="flex items-center gap-2">
                  <div className="bg-amber-500 rounded-full p-1.5">
                    <div className="bg-white rounded-full w-4 h-4 md:w-5 md:h-5 flex items-center justify-center">
                      <span className="text-amber-500 text-sm font-bold">B</span>
                    </div>
                  </div>
                  <span className="text-amber-400 font-bold text-base md:text-xl lg:text-2xl">BancaFlow</span>
                </div>
                <div className="text-white">
                  <span className="text-sm md:text-xl lg:text-2xl">Gerencie sua </span>
                   <span className="font-bold text-sm md:text-xl lg:text-2xl">Banca do Bicho</span>
                  <span className="text-amber-300 font-extrabold text-base md:text-2xl lg:text-3xl ml-2">100% Online!</span>
                </div>
              </div>
            </div>

            {/* Right side - Phone icon and CTA Button */}
            <div className="flex items-center gap-2 md:gap-4">
              <div className="hidden lg:flex items-center gap-2 text-white/80">
                <Smartphone className="h-6 w-6" />
                <span className="text-sm">App completo</span>
              </div>
              
              <div className="bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600 text-emerald-900 font-bold text-sm md:text-base px-4 md:px-6 py-2.5 md:py-3 rounded-lg shadow-lg group-hover:shadow-amber-400/30 transition-all duration-300 flex items-center gap-2 whitespace-nowrap animate-pulse-subtle">
                <span>Ver Agora</span>
                <ExternalLink className="h-4 w-4 md:h-5 md:w-5" />
              </div>
            </div>
          </div>

          {/* Mobile badge - visible only on small screens */}
          <div className="flex sm:hidden items-center justify-center gap-2 mt-2 text-xs text-white/80">
            <CheckCircle className="h-3 w-3 text-amber-400" />
            <span>Plataforma Completa e Segura</span>
          </div>
        </div>
      </div>
    </a>
  );
};

export default GlobalAdBannerBelowHeader;
